<template>
    <div class="modal vc_modal my_account_modal" :class="{ 'show': showStaticNatModal}">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content my_account_modal_content p_0">
                <button type="button" class="btn-close" @click="closeModal(false)"></button>
                <div class="modal-body p_0">
                    <h5 class="common_subtitle pb_15  font_18p border-lightgray-bottom pt_15 pl_15">{{ selectedNetwork?.public_ip }}</h5>
                    
                    <div class="p_20">
                        <div class="row">
                            <div class="col-12"> 
                                <p>Set the public IP to Static NAT.</p>
                                <div class="mb-3">
                                    <label for="cloud_server_id" class="col-form-label">Targeted server</label>
                                    <select class="form-select" id="cloud_server_id" v-model="form.cloud_server_id">
                                        <option  v-for="(cloudServer, index) in cloudServers" :key="'server_region_'+index" :value="cloudServer.id">
                                            {{ cloudServer.server_name }}
                                        </option>
                                    </select>
                                    <v-errors :errors="errorFor('cloud_server_id')"></v-errors>
                                </div>
                                <div class="mb-3">
                                    <div class="d_flex_start">
                                        <button type="button" class="btn btn-primary btn-md  width_100p" :disabled="lyLoading" @click.prevent="connectStaticNat">Set up</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "static-nat-modal",
    components: {},
    props: {
        showStaticNatModal: {
            type: Boolean,
            required: true
        },
        selectedNetwork: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            lyLoading: false,
            cloudServers: [],
            form: {
                cloud_network_id: this.selectedNetwork?.id,
                cloud_server_id:'',
            }
        }
    },
    watch: {

    },
    created() {
        this.loadCloudServers()
    },
    methods: {
        loadCloudServers() {
            this.axios.get('/platform-cloud-servers/'+this.selectedNetwork?.kt_platform)
            .then(({data}) => {
                this.cloudServers = data.data
                if(this.cloudServers.length > 0){
                    this.form.cloud_server_id = this.cloudServers[0].id
                }
            })
        },
        connectStaticNat() {
            this.$swal({
                title: 'Would you like to set up Static NAT?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, setup it!',
                confirmButtonColor: '#dd4b39',
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {
                    if(this.selectedNetwork.kt_platform == 'g'){
                        this.allErrors = null;
                        this.lyLoading = true;
                        this.axios.post('/set-up-static-nat',this.form)
                        .then((response) => {
                            if(response.data.success){
                                this.closeModal(true);
                                this.showSuccessMsg(response.data.message);
                            }else{
                                this.$swal({
                                    text: response.data.message,
                                    showCancelButton: false,
                                    confirmButtonText: 'Close!',
                                    confirmButtonColor: '#dd4b39',
                                    reverseButtons: true
                                })
                            }
                        }).catch((err) => {
                            this.allErrors = err.response.data.errors
                            this.showFailMsg(err.response.data.message);
                        }).finally(() => {
                            this.lyLoading = false;
                        });
                    }else{
                        this.allErrors = null;
                        this.lyLoading = true;
                        this.axios.post('/set-up-d-platform-static-nat',this.form)
                        .then((response) => {
                            if(response.data.success){
                                this.closeModal(true);
                                this.showSuccessMsg(response.data.message);
                            }else{
                                this.$swal({
                                    text: response.data.message,
                                    showCancelButton: false,
                                    confirmButtonText: 'Close!',
                                    confirmButtonColor: '#dd4b39',
                                    reverseButtons: true
                                })
                            }
                        }).catch((err) => {
                            this.allErrors = err.response.data.errors
                            this.showFailMsg(err.response.data.message);
                        }).finally(() => {
                            this.lyLoading = false;
                        });
                    }
                }
            });
        },
        closeModal(value) {
            this.$emit('closeModal', value)
        }
    }
}
</script>
<style scoped>
    .modal{
        background-color: rgb(0 0 0 / 15%);
    }
</style>
